import { Messages } from "../../lib/locale";

export const Polish: Messages = {
  name: "Polski",
  helpTitle: "Jak grać",
  help1: `Twoim zadaniem jest dowiedzieć się, jaki kraj jest ukryty w grze. Aby to zrobić, musisz wpisać nazwy losowych krajów. Wpisz kraj w polu wprowadzania i naciśnij Enter. Ten kraj pojawi się na mapie i zmieni kolor w zależności od tego, jak blisko jest ukrytego kraju. Im ciemniejszy kolor, tym bliżej jesteś odpowiedzi!`,
  help2: `Spójrz na przykład gry. Załóżmy, że w grze ukryta jest Japonia. Wtedy te kraje będą pomalowane w takich kolorach.`,
  help3: `Raz dziennie dostępny jest jeden nowy ukryty kraj. Lub przejdź do trybu swobodnego w ustawieniach i graj bez ograniczeń.`,
  France: "Francja",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "Korea Południowa",
  Aux1: `<b>["Kliknij", "Dotknij"]</b> kuli ziemskiej, aby rozpocząć!`,
  Loading: "Czekaj na to...",
  GameTitle: "Gra",
  Game1: "Wpisz tutaj nazwę kraju",
  Game2: "Wpisz",
  Game3: "Wpisz losową nazwę kraju i naciśnij Wpisz, aby rozpocząć",
  Game4: `Obracaj, <span>["klikaj", "dotykaj"]</span> i powiększaj kulę ziemską, aby znaleźć następny kraj do odgadnięcia`,
  Game5: "Nie znamy tego kraju",
  Game6: "Ten kraj jest już wprowadzony",
  Game7: "Ukrytym krajem była {answer}!",
  Game8: "Najbliższa granica",
  StatsTitle: "Statystyka",
  Stats1: "Ostatnia wygrana",
  Stats2: "Dzisiejsze domysły",
  Stats3: "Gry wygrane",
  Stats4: "Obecna passa",
  Stats5: "Maksymalna smuga",
  Stats6: "Średnie domysły",
  Stats7: "Średnie domysły",
  Stats8: "Resetowanie",
  Stats9: "Dzielić",
  Stats10: "Czy na pewno chcesz zresetować swój wynik?",
  Stats11: "Statystyki zostały usunięte.",
  Stats12: "Skopiowane do schowka!",
  SettingsTitle: "Ustawienia",
  Settings1: "Motyw dnia",
  Settings2: "Motyw nocny",
  Settings3: "Tryb daltonizmu",
  Settings4: "Tryb daltonizmu",
  Settings5: "Kraje",
  Settings7: "Język",
  Settings9: "Tryb darmowy",
  Settings10: "Wskazówki",
  Answer: "Odpowiadać",
  Closest: "Najbliższy",
  Guessed: "Zgadłem",
  PracticeMode: "Jesteś w trybie swobodnym.",
  PracticeExit: "Wyjdź z trybu swobodnego",
  PracticeNew: "Nowa darmowa gra",
  PlayAgain: "Zagraj ponownie",
  SortBy: "Sortuj według:",
  SortByGuesses: "kolejności odgadnięcia",
  SortByDistance: "odległości",
  Clipboard: "🌍🌍🌍\nOdgadłem ukryty kraj w dzisiejszym Globle w {X} domysłach\nCzy możesz zrobić to lepiej?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Zwycięstwo",
  Guesses: "Zgadywania",
  GuessesFlags: "Twoje domysły będą tutaj",
  Daily: "Codziennie",
  NextDailyIn: "Następny Codziennie",
  Learn: "Dowiedz się więcej o tym kraju"
};